/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

import React from 'react'
import { Col, Row } from "react-bootstrap";
import { loc } from '../../../core/utils';
import './../styles.css'
import { FaCheckCircle } from 'react-icons/fa';
import { FcCancel } from 'react-icons/fc';
import clsx from 'clsx';

export default function Order({ order, orderPageConfiguration, selectedOrder, selectOrder }) {

    return <div className={clsx(
        order.renewal ? 'search-order--result' : 'search-order--result-disabled',
        selectedOrder?.opl === order.opl? 'search-order-selected' : 'search-order-no-selected'
    )}
        onClick={() => order.renewal ? selectOrder(order) : null}>
        <Row>
            <Col sm={1}>
                {order.renewal ? <FaCheckCircle color="green" size={50} /> : <FcCancel size={50} />}
            </Col>

            <Col sm={6}>
                <div>
                    <span className="text-bold">{order.productName}</span>
                </div>

                <div>{order.opl}</div>
                <div>{order.shopName}</div>

            </Col>
            <Col sm={5}>

                <div>
                    <span className="text-bold"> {loc`Contract start date`} </span>
                    <span> : </span>
                    {order?.dateDebutContrat != null ? <span>{order.dateDebutContrat[2]}/{order?.dateDebutContrat[1]}/{order?.dateDebutContrat[0]}</span> : <span></span>}
                </div>
                <div>
                    <span className="text-bold"> {loc`Contract end date`} </span>
                    <span> : </span>
                    {order?.dateFinContrat != null ? <span>{order.dateFinContrat[2]}/{order.dateFinContrat[1]}/{order.dateFinContrat[0]}</span> : <span></span>}
                </div>
                <div>
                    <span className="text-bold"> {loc`Contract renewal date`} </span>
                    <span> : </span>
                    {order?.dateRenouvellement != null ? <span>{order.dateRenouvellement[2]}/{order.dateRenouvellement[1]}/{order.dateRenouvellement[0]}</span> : <span></span>}
                </div>
            </Col>
        </Row>


    </div>


}